import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={` https://order.codefusion.tech/restaurants/F3fJSO98p7SNu0n04b4T/locations/Ggg1OhvFyXga0MIu2GUR`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="320px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={` https://order.codefusion.tech/restaurants/F3fJSO98p7SNu0n04b4T/locations/Ggg1OhvFyXga0MIu2GUR`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="260px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
